<template>
  <div :class="['chart-card', { small }]">
    <div class="card-title">{{ title }}</div>
    <div class="card-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChartCardWrapper',
  props: { title: String, small: { type: Boolean, default: false } }
};
</script>

<style scoped>
.chart-card{background:var(--blue-3);padding:1rem;border-radius:1rem; width: 100%;}
.small {
  min-width: 18rem;
  width: fit-content
}
.card-title{font-weight:600;margin-bottom:0.5rem}
.card-body {
  height: 100%;
}
</style>